import type { CurationStatus } from './api/reviewsApi';

export const STATUS_LABEL: Record<CurationStatus, string> = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

/** Badge tone tokens — mirrors the DisputeStatusBadge palette (features/disputes). */
export const STATUS_TONE: Record<CurationStatus, string> = {
  PENDING: 'bg-amber-100 text-amber-700',
  APPROVED: 'bg-green-100 text-green-700',
  REJECTED: 'bg-red-100 text-red-700',
};

/** Only an APPROVED review/testimonial can be featured — the backend 409s otherwise,
 * and moving one OUT of APPROVED auto-unfeatures it server-side. */
export const canFeature = (status: CurationStatus): boolean => status === 'APPROVED';

export const excerpt = (text: string | null | undefined, max = 90): string => {
  if (!text) return '';
  const trimmed = text.trim();
  return trimmed.length > max ? `${trimmed.slice(0, max).trimEnd()}…` : trimmed;
};
